import { HorizontalSeparator } from '@evolve/common-ui';
import React from 'react';
import { useLayoutControlContext } from '../../contexts';
import { cn } from '../../utils';
import { PageLink } from '../page-link';
import { TSidebarElement } from './Sidebar';

// export type TSidebarElement = {
//   label: string;
//   active: boolean;
//   to: string;
// };

interface SidebarProps {
  elements: TSidebarElement[];
  title?: string;
}

export const SidebarNew = ({ elements, title }: SidebarProps) => {
  const { sidebarOpen } = useLayoutControlContext();

  return (
    <div
      data-testid="sidebar"
      className={cn('sidebar-container', { closed: !sidebarOpen })}
    >
      {title && <div className="sidebar-container__title">{title}</div>}
      <div className="sidebar-container__body">
        {elements.map(({ label, to, active }, i) => (
          <div key={i}>
            <HorizontalSeparator />
            <div
              className={cn('sidebar-container__body--element', {
                current: active,
              })}
            >
              <PageLink className="w-full px-4 py-2" to={to}>
                {label}
              </PageLink>
            </div>
          </div>
        ))}
        <HorizontalSeparator />
      </div>
    </div>
  );
};
